// Sơ đồ kiến trúc Avatar — in sau `avatar init` thành công để user thấy "độ
// hoành tráng" + 8 khối kết nối vào lõi AVATAR.
//
// Bố cục CÂY (tree) thay vì hub-and-spoke 2 cột: đường nối ├──/└── luôn đứng
// ĐẦU dòng → KHÔNG bao giờ lệch dù font terminal hay chữ tiếng Việt có dấu render
// rộng khác nhau (hub 2 cột cũ vỡ vì phụ thuộc căn ký tự pixel-perfect ở GIỮA dòng).
//
// Màu gradient cam→tím nhất quán banner. Bọc boxen viền tím. Fallback plain non-TTY.
import boxen from "boxen";
import { chalk } from "./terminal-logger.js";

// 8 khối — tên + 1 dòng mô tả vai trò + cách nó kết nối khối khác.
interface Block {
  name: string;
  role: string;
}

const BLOCKS: readonly Block[] = [
  { name: "SKILLS", role: "kỹ năng tái dùng — Claude gọi khi cần" },
  { name: "AGENTS", role: "subagent chuyên trách — skills điều phối" },
  { name: "WORKFLOW", role: "orchestrate nhiều agent song song" },
  { name: "TOOLS", role: "hook gác cổng mọi thao tác" },
  { name: "SECURITY", role: "chặn push/secret rủi ro trước khi xảy ra" },
  { name: "LOG TRACKING", role: "ghi nhận mọi hành động để truy vết" },
  { name: "AUTO SUPPORT", role: "tự xử lý / nhắc đúng lúc cần" },
  { name: "KNOWLEDGE", role: "sổ kinh nghiệm nuôi cả hệ thống" },
];

const CORE_COLOR: readonly [number, number, number] = [125, 88, 217]; // tím
const NAME_COLOR: readonly [number, number, number] = [205, 95, 130]; // hồng-tím
const LINE_COLOR: readonly [number, number, number] = [150, 120, 200]; // tím nhạt

function tty(): boolean {
  return (process.stdout.isTTY ?? false) && chalk.level > 0;
}
function paint(c: readonly [number, number, number], s: string, bold = false): string {
  if (!tty()) return s;
  const fn = chalk.rgb(c[0], c[1], c[2]);
  return bold ? fn.bold(s) : fn(s);
}
function dim(s: string): string {
  return tty() ? chalk.dim(s) : s;
}

// Render cây kiến trúc (chưa bọc boxen). Mỗi khối 1 dòng, nối ├──/└── đầu dòng.
export function renderArchitectureDiagram(): string {
  const lines: string[] = [];

  // Lõi.
  lines.push(
    `${paint(CORE_COLOR, "◆", true)} ${paint(CORE_COLOR, "AVATAR", true)}  ${dim("— lõi điều phối")}`,
  );
  lines.push(paint(LINE_COLOR, "│"));

  // 8 khối — nhánh con. Khối cuối dùng └── thay ├──.
  BLOCKS.forEach((b, i) => {
    const isLast = i === BLOCKS.length - 1;
    const branch = paint(LINE_COLOR, isLast ? "└──" : "├──");
    lines.push(`${branch} ${paint(NAME_COLOR, b.name, true)}  ${dim(b.role)}`);
  });

  return lines.join("\n");
}

// In sơ đồ kèm tiêu đề, bọc boxen viền tím (đồng bộ welcome/init box).
export function printArchitectureDiagram(): void {
  const title = paint(CORE_COLOR, "Kiến trúc Avatar — 8 khối quanh một lõi", true);
  const footer = dim("Mọi khối chia sẻ cùng một lõi, hợp thành 1 hệ thống cho cả đội.");

  const body = `${title}\n\n${renderArchitectureDiagram()}\n\n${footer}`;

  // textAlignment "left" — sơ đồ cây không cần căn giữa; giữ ├──/└── thẳng mép trái.
  process.stdout.write(
    `\n${boxen(body, {
      padding: 1,
      borderStyle: "round",
      borderColor: "magenta",
      textAlignment: "left",
    })}\n`,
  );
}
